// src/utils/statusBarConfig.js
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

// Regular function, not a hook
export const configureStatusBar = (pathname) => {
  if (!Capacitor.isNativePlatform()) return;

  const defaultConfig = { color: "#ffffff", style: Style.Light };

  const statusBarConfig = {
    "/dashboard": defaultConfig,
    "/my-rides": { color: "#ffffff", style: Style.Dark },
    "/view-rides": defaultConfig,
    "/search-rides": { color: "#ffffff", style: Style.Dark },
    "/post-ride": defaultConfig,
    "/profile": defaultConfig,
  };

  const config =
    statusBarConfig[pathname] || statusBarConfig["/"] || defaultConfig;

  StatusBar.setBackgroundColor({ color: config.color });
  StatusBar.setStyle({ style: config.style });
};
